import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { Stack, createTheme } from '@mui/material';
import { InnerThemeProvider, PROMETHEAN_NEUTRAL_WHITE } from '../..';
import { SKIP_TO_MAIN_CONTENT_ID } from '../../header';
import { Banner } from './banner';
import { Columns } from './columns';
import { Carousel } from './carousel/carousel';
import { CircleSection } from './circle';
import { Bottom } from './bottom';
import { StyledRowLayout } from './styles';
var theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 1215,
      md: 1440,
      lg: 1920,
      xl: 2500
    }
  }
});
export var MarketingTemplate = function MarketingTemplate(_ref) {
  var _ref$skipTo = _ref.skipTo,
    skipTo = _ref$skipTo === void 0 ? true : _ref$skipTo,
    _ref$isPublic = _ref.isPublic,
    isPublic = _ref$isPublic === void 0 ? true : _ref$isPublic,
    handleSignIn = _ref.handleSignIn,
    handleSignUp = _ref.handleSignUp,
    appName = _ref.appName,
    _ref$modules = _ref.modules,
    modules = _ref$modules === void 0 ? [] : _ref$modules,
    supportLink = _ref.supportLink,
    learnMoreText = _ref.learnMoreText,
    hideLearnMore = _ref.hideLearnMore;
  var renderModules = function renderModules() {
    var getModule = function getModule(data, index) {
      switch (data.type) {
        case 'banner':
          return /*#__PURE__*/React.createElement(Banner, _extends({
            key: "banner-".concat(index)
          }, data.config, {
            appName: appName,
            handleSignIn: handleSignIn,
            handleSignUp: handleSignUp
          }));
        case 'columns':
          return /*#__PURE__*/React.createElement(Columns, {
            key: "columns-".concat(index),
            data: data.config
          });
        case 'carousel':
          return /*#__PURE__*/React.createElement(Carousel, _extends({
            key: "carousel-".concat(index)
          }, data.config));
        case 'circle':
          return /*#__PURE__*/React.createElement(CircleSection, _extends({
            key: "circle-".concat(index)
          }, data.config));
      }
    };
    return modules.map(function (v, vi) {
      if (Array.isArray(v)) {
        return /*#__PURE__*/React.createElement(StyledRowLayout, {
          key: "group-".concat(vi),
          className: "EmbersTemplate-marketingGroup-root"
        }, v.map(function (u, ui) {
          return /*#__PURE__*/React.createElement("div", {
            key: "".concat(vi, "-").concat(ui),
            className: "EmbersTemplate-marketingGroup-item",
            style: {
              marginBottom: v.length > 1 && ui === 0 ? 48 : 0
            }
          }, getModule(u.type === 'carousel' ? _objectSpread(_objectSpread({}, u), {}, {
            config: _objectSpread(_objectSpread({}, u.config), {}, {
              fullScreen: false
            })
          }) : u, ui));
        }));
      } else {
        return getModule(v, vi);
      }
    });
  };
  return /*#__PURE__*/React.createElement(InnerThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Stack, {
    flex: 1,
    alignItems: "center",
    style: {
      background: PROMETHEAN_NEUTRAL_WHITE
    },
    id: skipTo ? SKIP_TO_MAIN_CONTENT_ID : void 0,
    className: "EmbersTemplate-marketing-root",
    role: "main"
  }, renderModules(), /*#__PURE__*/React.createElement(Bottom, {
    isPublic: isPublic,
    appName: appName,
    supportLink: supportLink,
    learnMoreText: learnMoreText,
    hideLearnMore: hideLearnMore,
    handleSignIn: handleSignIn,
    handleSignUp: handleSignUp
  })));
};